import gql from 'graphql-tag';

// The signed-in user's current roles: the ones saved at login go stale when a role is granted or removed.
const GET_MY_ROLES = gql`
  query getMyRoles {
    me {
      _id
      roles
    }
  }
`;

// recupere les 10 derniers coeurs recus par la box
const GET_HEARTS = gql`
  query savGetHeartsByBox($selectedLovebox: String!) {
    savGetHeartsByBox(boxId: $selectedLovebox) {
      _id, recipient, date, seen
    }
  }
`;

// recupere les 10 derniers msg recu
const GET_MSG = gql`
  query savGetMessagesByBox($boxId: String!, $skip: Int) {
    savGetMessagesByBox(boxId: $boxId, skip: $skip) @connection(key: "savGetMessagesByBox", filter:["boxId"]) {
      _id, contentType, status { label }, date, senderUser { email, firstname }
    }
  }
`;
const GET_USER_FEED = gql`
  query savGetMessagesByUser($boxId: String!, $userId: String!) {
    savGetMessagesByUser(boxId: $boxId, userId: $userId) {
      _id
      contentType
      status { label }
      date
      senderUser { email firstname }
      messagePrivacy
    }
  }
`;

const GET_BOX_PRIVACY_POLICY = gql`
  query savGetPrivacyPolicyForBox($boxId: String!, $userId: String!) {
    savGetPrivacyPolicyForBox(boxId: $boxId, userId: $userId)
  }
`;

// recupere les box associées a un compte
const GET_BOXES = gql`
  query savGetBoxes($email: String!) {
    savGetBoxes(email: $email) {
      name, _id, nickname
    }
  }
`;

// recupere les box en test
const GET_TEST_BOXES = gql`
  query savGetTestBoxes($testGroupName: String!) {
    savGetTestBoxes(testGroupName: $testGroupName) {
      _id
      macAddress
      versions {
        currentVersion
        targetVersion
        lastReceivedVersion
        testGroup
      }
    }
  }
`;

// recupere les informations associées a une box
const GET_BOX_DATA = gql`
  query savGetBoxData($boxId: String, $macAddress: String, $pairing: String) {
    savGetBoxData(boxId: $boxId, macAddress: $macAddress, pairing: $pairing) {
      _id
      name
      version
      hardware
      language
      pairing
      isConnected
      lastConnection
      admin
      adminId
      senders
      settings
      hasColor
      macAddress
      macAddr
      versions {
        testGroup
        currentVersion
        targetVersion
      }
      lastRequests
      channelsIds
    }
  }
`;

// recupere les informations associées au user
const GET_USER_DATA = gql`
  query savGetUserData($email: String!) {
    savGetUserData(email: $email) {
      _id
      firstname
      device {
        os, appVersion,
        model, brand,
        osVersion, deviceType
      },
      troubleshoot {
        notifications {
          date
          success
          failureReason
        }
      }
      loveCoins
      timezone
      language
      createdAt
      relations {
        _id
        name
        loveGoal
        streak
        relationType
        boxId
      }
      boxes {
        _id
        nickname
        isAdmin
        hasColor
        pairingCode
        hardware
      }
      subscription {
        hasFreePostcard
        platform
        subscribed
      }
      settings {
        streak
        loveGoal
        reminders
      }
    }
  }
`;

// recupere les informations associées au user
const GET_USER_DATA_PHOTOBOOK = gql`
  query savGetUserDataPhotoBook($email: String!) {
    savGetUserDataPhotoBook(email: $email) {
      _id
      firstname
      boxes {
        _id
        photoBook
        macAddress
        isAdmin
      }
      emails {
        customerAddress
      }
    }
  }
`;

const GET_ADMIN_USER_BOX_PHOTOBOOK = gql`
  query savGetAdminUserBoxPhotoBook($macAddress: String!) {
    savGetAdminUserBoxPhotoBook(macAddress: $macAddress) {
      _id
      boxes {
        _id
        macAddress
      }
      emails {
        address
      }
    }
  }
`;

const GET_POTENTIAL_ADMIN_USER_BOX_PHOTOBOOK = gql`
  query savGetPotentialUserAdminBoxPhotoBook($email: String!) {
    savGetPotentialUserAdminBoxPhotoBook(email: $email) {
      _id
      boxes {
        _id
        macAddress
      }
      emails {
        address
      }
    }
  }
`;

// recupere la liste des utilisateurs avec le role sav-agent
const GET_SAV_AGENTS = gql`
  query savGetAgents {
    savGetAgents {
      email, _id
    }
  }
`;

// ajoute le role sav-agent a l'email envoyé
const ADD_SAV_AGENT = gql`
  query savAddAgent($email: String!) {
    savAddAgent(email: $email)
  }
`;

// supprime le role sav-agent a l'user envoyé
const RM_SAV_AGENT = gql`
  query savRmAgent($agentId: String!) {
    savRmAgent(agentId: $agentId)
  }
`;

const GET_MESSAGES_BY_BOX = gql`
  query savManagerGetMessagesByBox($boxId: String!) {
    savManagerGetMessagesByBox(boxId: $boxId) {
      _id, date, sender, type, content, text
    }
  }
`;

const GET_RANDOM_MESSAGES = gql`
  query savGetRandomAnonymizedMessages($limit: Int) {
    savGetRandomAnonymizedMessages(limit: $limit) {
      _id, url, channel
    }
  }
`;

const GET_PENDING_STICKERS = gql`
  query pendingStickers {
    pendingStickers {
      _id
      base64
    }
  }
`;

const GET_MONTHLY_STICKERS = gql`
  query savMonthlyAcceptedCommunityStickers {
    savMonthlyAcceptedCommunityStickers {
      _id
      base64
    }
  }
`;

const GET_PENDING_PREMIUM_GIFS = gql`
  query savPendingPremiumGifs {
    savPendingPremiumGifs {
      _id
      autoReleaseDate
      base64
      base64Outlined
      name
      rank
      designerRank
    }
  }
`;

const GET_ACCEPTED_PREMIUM_GIFS = gql`
  query savAcceptedPremiumGifs {
    savAcceptedPremiumGifs {
      _id
      base64
      base64Outlined
      rank
      designerRank
      name
      tags
    }
  }
`;

const GET_VERSIONS = gql`
  query savGetVersions {
    savGetVersions {
      iosBetaVersion
      androidBetaVersion
      iosLastVersion
      androidLastVersion
      minimalVersion
      lovepixLastVersion
    }
  }
`;

const GET_MOST_USED_GIF = gql`
  query savMostUsedGif {
    savMostUsedGif {
      _id
      base64
      base64Outlined
      rank
      name
      tags
    }
  }
`;

const GET_TAGS = gql`
  query Tags {
    tags: savTags {
      _id
      titleEn
      titleFr
      rank
      isActive
    }
  }
`;
const GET_AMBASSADORS = gql`
  query savGetAmbassadors {
    savGetAmbassadors {
      _id
      firstname
      email
      language
      discountCode
      boxesSold
    }
  }
`;

const GET_FIRMWARE_RELEASES = gql`
  {
    savGetFirmwareReleases {
      active
      version
      date
      limit
      updated
      status {
        succeed
        inProgress
        failed
        failedTooManyAttempts
        failedButConnected
        failedMacAddresses
        failedButConnectedMacAddresses
        failedTooManyAttemptsMacAddresses

      }
    }
  }
`;

const GET_FACTORY_SETTINGS = gql`
  {
    savGetFactorySettings {
      color
      companyId
      screenType
      pcbVersion
    }
  }
`;

const GET_COMPANIES = gql`
  {
    savGetCompanies {
      _id
      name
    }
  }
`;

const GET_TEMPLATES = gql`
  query savGetTemplates($authorId: String) {
    savGetTemplates(authorId: $authorId) {
      _id
      background {
        url
      }
      backgroundCover
      elements {
        x
        y
        rotate
        type
        fontSize
        fontFamily
        color
        width
        height
        textAlign
        defaultTextFr
        defaultTextEn
      }
      name
      premium
      internalNote
      releaseDate
      status
      subCategories
      thumbnailFr
      thumbnailEn
      isGif
      rank
      ranks {
        id
        rank
      }
    }
  }
`;

const GET_TEMPLATE_CATEGORIES = gql`
  query savGetTemplateCategories {
    savGetTemplateCategories {
      _id
      type
      titleFr
      titleEn
      subCategories {
        _id
        type
        titleFr
        titleEn
        hidden
        pinned
        presentation
        isExcludeRandom
      }
    }
  }
`;

const GET_RELATION_FEED = gql`
  query savGetRelationFeed($userId: String, $channelId: String,) {
    savGetRelationFeed(userId: $userId, channelId: $channelId,) {
      _id
      channel
      recipient
      date
      status {
        label
      }
      statusList {
        label
        date
      }
      senderUser {
        _id
        firstName
        email
      }
      privacyPolicy
    }
  }
`;

const GET_RELATION_FEED_LENGTH = gql`
  query savGetRelationFeedLength($userId: String, $channelId: String,) {
    savGetRelationFeedLength(userId: $userId, channelId: $channelId)
  }
`;

const GET_REFERRAL_DATA = gql`
  query savGetReferralData($userId: String!) {
    savGetReferralData(userId: $userId) {
      discountCode
      godsons
    }
  }
`;

const GET_CHANNELS = gql`
  query savGetChannels($boxId: String) {
    savGetChannels(boxId: $boxId) {
      _id
      followers
      nameFr
      nameEn
      description
      AIPrompt
      AIPromptStatus
      generatedMessageFontSize
      generatedMessageColor
      generatedMessageMarginRight
      generatedMessageMarginLeft
      generatedMessageMarginBottom
      generatedMessageMarginTop
      generatedMessageFontFamily
      picture
      premium
      hidden
      spicy
      countChannelMessages {
        total
        neverSent
      }
      privateChannelSettings {
        userId
      }
    }
  }
`;

const GET_CHANNEL_PREVIEWS = gql`
  query savGetChannelPreviews($channelId: String!) {
    savGetChannelPreviews(channelId: $channelId) {
      thumbnailEn
      thumbnailFr
      _id
      AIGeneratedTextSubCategory
      AIGeneratedText
      lastSent
      creationDate
    }
  }
`;

const COLOR_BATCH_PREVIEW_FIELDS = gql`
  fragment SavColorBatchPreviewFields on SavColorBatchPreview {
    target
    summary {
      entryCount
      uniqueMacCount
      duplicateCount
      invalidCount
      foundCount
      missingCount
      boxCount
      eligibleCount
      alreadyTargetCount
      notLovepixCount
    }
    invalidEntries
    missingMacs
    sharedMacs
    suggestions {
      entry
      confidence
      candidateCount
      candidates {
        macAddress
        hasColor
        hardware
        confidence
        mistake
      }
    }
    boxes {
      boxId
      macAddress
      hasColor
      convertedToBlackAndWhiteManually
      hardware
      pairing
      status
    }
  }
`;

const PREVIEW_COLOR_BATCH = gql`
  query savPreviewColorBatch($macAddresses: [String!]!, $target: SavColorBatchTarget!) {
    savPreviewColorBatch(macAddresses: $macAddresses, target: $target) {
      ...SavColorBatchPreviewFields
    }
  }
  ${COLOR_BATCH_PREVIEW_FIELDS}
`;

const GET_KEEP_LINKS = gql`
  query savGetKeepLinks($email: String, $uid: String, $pairingCode: String) {
    savGetKeepLinks(email: $email, uid: $uid, pairingCode: $pairingCode) {
      _id
      uid
      pairingCode
      screenType
      pairedWithoutFactoryRegistration
      pairedWithoutFactoryRegistrationAt
      screenTypeHeal {
        from
        to
        at
        count
      }
      createdAt
      pairedUsers {
        userId
        role
        email
        name
        pairedAt
      }
      removedPairedUsersCount
      messageCount
      syncedMessageCount
      lastMessageAt
      firstSyncedAt
    }
  }
`;

const GET_KEEP_USAGE_STATS = gql`
  query savGetKeepUsageStats($since: String, $until: String) {
    savGetKeepUsageStats(since: $since, until: $until) {
      since
      until
      days {
        date
        newSetups
        firstSyncs
      }
      totalLinks
      linksFactoryRegistered
      linksPairedWithoutFactoryRegistration
      screenTypeHealedCount
      linksWithOwner
      linksWithSyncedMessage
      totalMessages
      syncedMessages
      syncedMessagePercent
    }
  }
`;

export {
  ADD_SAV_AGENT,
  GET_ACCEPTED_PREMIUM_GIFS,
  GET_ADMIN_USER_BOX_PHOTOBOOK,
  GET_AMBASSADORS,
  GET_BOX_DATA,
  GET_BOX_PRIVACY_POLICY,
  GET_BOXES,
  GET_COMPANIES,
  GET_FACTORY_SETTINGS,
  GET_FIRMWARE_RELEASES,
  GET_HEARTS,
  GET_MESSAGES_BY_BOX,
  GET_MONTHLY_STICKERS,
  GET_MOST_USED_GIF,
  GET_MSG,
  GET_PENDING_PREMIUM_GIFS,
  GET_PENDING_STICKERS,
  GET_POTENTIAL_ADMIN_USER_BOX_PHOTOBOOK,
  GET_RANDOM_MESSAGES,
  GET_REFERRAL_DATA,
  GET_RELATION_FEED_LENGTH,
  GET_RELATION_FEED,
  GET_SAV_AGENTS,
  GET_TAGS,
  GET_TEMPLATE_CATEGORIES,
  GET_TEMPLATES,
  GET_TEST_BOXES,
  GET_USER_DATA,
  GET_USER_DATA_PHOTOBOOK,
  GET_USER_FEED,
  GET_VERSIONS,
  RM_SAV_AGENT,
  GET_CHANNELS,
  GET_CHANNEL_PREVIEWS,
  COLOR_BATCH_PREVIEW_FIELDS,
  PREVIEW_COLOR_BATCH,
  GET_MY_ROLES,
  GET_KEEP_LINKS,
  GET_KEEP_USAGE_STATS,
};



// WEBPACK FOOTER //
// ./src/query/query.js